/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Row, Col  } from 'reactstrap'

import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';

class JsonKeywordValue extends React.Component
{

  constructor(props)
  {
    super();

  }

  render()
  {
    return (
      <div>
        <Row>
          <Col>
            <JSONInput
              id          = 'a_unique_id'
              placeholder = { JSON.parse(this.props.keywordAndValue.displayedValue) }
//              colors      = { darktheme }
              locale      = { locale }
              height      = '550px'
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default JsonKeywordValue
